import api from "./api";

export function getAccommodationPage(country_id) {
  return api.get(`/accomationpage/${country_id}`);
}
